import { useCallback, useMemo, useReducer } from "react";
function reducer(state, action) {
    switch (action.type) {
        case "sort": {
            return Object.assign(Object.assign({}, state), { sorting: {
                    column: action.column,
                    direction: action.direction,
                } });
        }
        case "select": {
            const selection = Object.assign({}, state.selection);
            (Array.isArray(action.item) ? action.item : [action.item]).forEach(item => {
                const selected = typeof action.selected === "function" ? action.selected(selection[state.hash(item)]) : action.selected;
                if (selected)
                    selection[state.hash(item)] = item;
                else
                    delete selection[state.hash(item)];
            });
            return Object.assign(Object.assign({}, state), { selection });
        }
        case "clear-selection": {
            return Object.assign(Object.assign({}, state), { selection: {} });
        }
        case "set-visibility": {
            return Object.assign(Object.assign({}, state), { visibility: action.visibility });
        }
    }
}
export function getColumnVisibility(columns, id, saved) {
    const { visibility } = columns[id] || {};
    const savedOrDefault = (def) => (typeof (saved === null || saved === void 0 ? void 0 : saved[id]) === "boolean" ? saved[id] : def);
    if (!visibility) {
        return savedOrDefault(true);
    }
    else {
        switch (visibility.type) {
            case "always-visible": {
                return true;
            }
            case "hidden": {
                return false;
            }
            case "configurable": {
                return savedOrDefault(visibility.default);
            }
            case "depends-on": {
                return getColumnVisibility(columns, visibility.column);
            }
        }
    }
}
export function getColumnsVisibility(columns, visibility) {
    const columnsMap = Object.fromEntries(columns.map(c => [c.id, c]));
    return Object.fromEntries(columns.map(c => [c.id, getColumnVisibility(columnsMap, c.id, visibility)]));
}
export function useTableState(columns, hash, initialValue = undefined) {
    const [state, dispatch] = useReducer(reducer, {
        visibility: {},
        sorting: initialValue,
        selection: {},
        hash,
    });
    const visibility = useMemo(() => getColumnsVisibility(columns, state.visibility), [columns, state]);
    const rstate = useMemo(() => (Object.assign(Object.assign({}, state), { visibility })), [state, visibility]);
    const onSort = useCallback((column, direction) => dispatch({ type: "sort", column, direction }), []);
    const onSelect = useCallback((item, selected) => dispatch({ type: "select", item, selected }), []);
    const onClearSelection = useCallback(() => dispatch({ type: "clear-selection" }), []);
    const onToggleVisibility = useCallback((visibility) => dispatch({ type: "set-visibility", visibility }), []);
    return [rstate, onSort, onSelect, onClearSelection, onToggleVisibility];
}
export default useTableState;
//# sourceMappingURL=use-table-state.js.map